module.exports = __webpack_public_path__ + "static/media/time-on-call-green-icon.62406076.svg";